import {
  TaggingPlan,
  TaggingPlanAttributes,
  TaggingPlanCreationAttributes,
  TaggingPlanUpdateAttributes
} from "~/models/TaggingPlan";
import { ApiClient } from '~/apiClients/ApiClient';

export default class TaggingPlanApiClient extends ApiClient {
  private readonly BASE_URL: string = '/api/tagging-plan';

  public async provideList() {
    const response = await this.get(this.BASE_URL);
    return response.data.map((attributes: TaggingPlanAttributes) => new TaggingPlan(attributes));
  }
  public async provideById(id: number): Promise<TaggingPlan> {
    const response = await this.get(this.BASE_URL + `/${id}`);
    return new TaggingPlan(response.data);
  }

  public async create(attributes: TaggingPlanCreationAttributes): Promise<TaggingPlan> {
    const response = await this.post(this.BASE_URL, attributes);
    return new TaggingPlan(response.data);
  }

  public async update(attributes: TaggingPlanUpdateAttributes): Promise<TaggingPlan> {
    const response = await this.patch(this.BASE_URL, attributes);
    return new TaggingPlan(response.data);
  }

  public async delete(id: number) {
    return super.delete(this.BASE_URL, {id});
  }

  public async publish(isPreview: boolean, id: number) {
    return await this.post(this.BASE_URL + `/publish`, { id, isPreview });
  }

  public async isPublished(id: number) {
    const response = await this.post(this.BASE_URL + `/is-published`, { id });
    return response?.data?.status;
  }

  public async createDraftVersion(id: number) {
    const response = await this.post(this.BASE_URL + `/create-draft-version`, { id });
    return response?.data;
  }
}
